(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function initStickyHeader() {
    var headerSection = document.querySelector('.shopify-section-header-sticky, .section-header');
    if (!headerSection) return;

    var threshold = 24;
    var ticking = false;

    function update() {
      ticking = false;
      if (window.scrollY > threshold) {
        headerSection.classList.add('wl-header-scrolled');
        document.documentElement.classList.add('wl-header-scrolled');
      } else {
        headerSection.classList.remove('wl-header-scrolled');
        document.documentElement.classList.remove('wl-header-scrolled');
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    update();
  }

  function initFaqAccordion() {
    var roots = document.querySelectorAll('[data-wl-faq]');
    roots.forEach(function (root) {
      var items = root.querySelectorAll('details.wl-faq-item, details.wl-faq__item');
      items.forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          items.forEach(function (other) {
            if (other !== details && other.open) other.open = false;
          });
        });
      });
    });
  }

  function initTestimonialsCarousel() {
    var rails = document.querySelectorAll('[data-wl-testimonials]');
    rails.forEach(function (rail) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var paused = false;
      var step = function () {
        if (paused || !rail.isConnected) return;
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 0) return;
        var next = rail.scrollLeft + 1;
        if (next >= max - 1) {
          rail.scrollLeft = 0;
        } else {
          rail.scrollLeft = next;
        }
      };

      var timer = window.setInterval(step, 30);

      rail.addEventListener('mouseenter', function () {
        paused = true;
      });
      rail.addEventListener('mouseleave', function () {
        paused = false;
      });
      rail.addEventListener('touchstart', function () {
        paused = true;
      }, { passive: true });
      rail.addEventListener('touchend', function () {
        window.setTimeout(function () {
          paused = false;
        }, 2500);
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          window.clearInterval(timer);
          timer = null;
        } else if (!timer) {
          timer = window.setInterval(step, 30);
        }
      });
    });
  }

  function initScrollReveals() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = document.querySelectorAll('.wl-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    items.forEach(function (el) {
      if (!el.style.getPropertyValue('--wl-reveal-delay')) {
        var siblingIndex = 0;
        var parent = el.parentElement;
        if (parent) {
          var siblings = Array.prototype.filter.call(parent.children, function (child) {
            return child.classList && child.classList.contains('wl-reveal');
          });
          siblings.forEach(function (sib, i) {
            if (sib === el) siblingIndex = i;
          });
        }
        el.style.setProperty('--wl-reveal-delay', siblingIndex * 90 + 'ms');
      }
      observer.observe(el);
    });
  }

  function samePageHash(link) {
    var href = link.getAttribute('href');
    if (!href) return '';

    if (href.charAt(0) === '#') return href.slice(1);

    try {
      var url = new URL(href, window.location.href);
      if (url.hash && url.pathname === window.location.pathname && url.search === window.location.search) {
        return url.hash.slice(1);
      }
    } catch (err) {
      return '';
    }

    return '';
  }

  function initSmoothScrollCues() {
    var links = document.querySelectorAll('[data-wl-smooth-scroll], a.wl-hero__scroll-cue, a.wl-categories__card');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = samePageHash(link);
        if (!id) return;

        var target = document.getElementById(id);
        if (!target) return;

        event.preventDefault();

        var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
        var offset = header ? header.getBoundingClientRect().height : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 8;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({
          top: Math.max(0, top),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });

        if (history.replaceState) {
          history.replaceState(null, '', '#' + id);
        }
      });
    });
  }

  onReady(function () {
    initStickyHeader();
    initFaqAccordion();
    initTestimonialsCarousel();
    initScrollReveals();
    initSmoothScrollCues();
  });
})();
